import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import axios from 'axios';
import { useAuth } from '../components/AuthContext';
import { useTerminologia } from '../hooks/useTerminologia';
import { getMenuAdminDefinition } from '../constants/menuAdminDefinition';
import ArbolMenuCheckboxes, { hojasDeMenuItem } from '../components/ArbolMenuCheckboxes';
import LoadingOverlay from '../components/LoadingOverlay';

const HOST_API = process.env.REACT_APP_URL;

// La pantalla de permisos nunca se muestra a si misma como opcion: el Perfil Administrador
// no puede reconfigurar sus propios permisos (ver misma restriccion en App.js).
const RESTRINGIDOS = ['permisosMenuPerfilAdministrador'];

const PermisosMenuPerfilAdministrador = () => {
    const toast = useRef(null);
    const { administracionId } = useAuth();
    const t = useTerminologia();

    const definicionMenu = useMemo(() => getMenuAdminDefinition(t), [t]);

    const [ocultos, setOcultos] = useState(new Set());
    const [loading, setLoading] = useState(true);
    const [guardando, setGuardando] = useState(false);

    useEffect(() => {
        if (!administracionId) return;
        setLoading(true);
        axios.get(`${HOST_API}api/perfilAdminMenu/GetMenuOcultos`, { params: { administracionId } })
            .then(({ data }) => setOcultos(new Set(data ?? [])))
            .catch(() => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudieron cargar los permisos actuales', life: 3000 });
                setOcultos(new Set());
            })
            .finally(() => setLoading(false));
    }, [administracionId]);

    const toggleItem = (key) => {
        setOcultos(prev => {
            const next = new Set(prev);
            if (next.has(key)) next.delete(key); else next.add(key);
            return next;
        });
    };

    const toggleGrupo = (item, marcar) => {
        const claves = hojasDeMenuItem(item, RESTRINGIDOS);
        setOcultos(prev => {
            const next = new Set(prev);
            claves.forEach(k => marcar ? next.delete(k) : next.add(k));
            return next;
        });
    };

    const guardar = async () => {
        setGuardando(true);
        try {
            await axios.post(`${HOST_API}api/perfilAdminMenu/SaveMenuOcultos`, {
                administracionId,
                menuKeysOcultos: Array.from(ocultos),
            });
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Permisos guardados correctamente', life: 3000 });
        } catch (err) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: err?.response?.data?.errorDisplay || 'No se pudieron guardar los permisos', life: 4000 });
        } finally {
            setGuardando(false);
        }
    };

    return (
        <>
            <h4>Permisos Perfil Administrador</h4>
            <p style={{ color: '#667085', fontSize: '0.9rem', marginTop: '-0.5rem' }}>
                Elegí qué pantallas puede usar el rol "Perfil Administrador" en esta administradora. Los cambios aplican a todos los usuarios con ese perfil.
            </p>
            <br />
            <Toast ref={toast} />

            <LoadingOverlay visible={loading} />
            {!loading && (
                <>
                    <div className="mb-4">
                        <ArbolMenuCheckboxes
                            definicionMenu={definicionMenu}
                            ocultos={ocultos}
                            onToggleItem={toggleItem}
                            onToggleGrupo={toggleGrupo}
                            restringidos={RESTRINGIDOS}
                        />
                    </div>
                    <Button label="Guardar" icon="pi pi-check" onClick={guardar} loading={guardando} />
                </>
            )}
        </>
    );
};

export default PermisosMenuPerfilAdministrador;
